var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartHeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.25,14.41v1.2c4.45.62,7.5,1.88,7.5,3.34,0,2.07-6.16,3.75-13.75,3.75s-13.75-1.68-13.75-3.75c0-1.46,3.05-2.72,7.5-3.34v-1.2c-5.16.79-8.75,2.52-8.75,4.54,0,2.76,6.72,5,15,5s15-2.24,15-5c0-2.02-3.59-3.75-8.75-4.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.55,19c-1.65-2.21-2.35-4.38-2.08-6.47.16-1.23.61-2.08,1.05-2.9.39-.73.77-1.43.95-2.42.39-2.05-.26-4.32-1.93-6.76l.86-.46c1.8,2.62,2.49,5.1,2.07,7.36-.21,1.11-.63,1.9-1.04,2.65-.42.79-.82,1.53-.96,2.62-.24,1.87.4,3.85,1.92,5.88l-.83.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.55,19c-1.65-2.21-2.35-4.38-2.08-6.47.16-1.23.61-2.08,1.05-2.9.39-.73.77-1.43.95-2.42.39-2.05-.26-4.32-1.93-6.76l.86-.46c1.8,2.62,2.49,5.1,2.07,7.36-.21,1.11-.63,1.9-1.04,2.65-.42.79-.82,1.53-.96,2.62-.24,1.87.4,3.85,1.92,5.88l-.83.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.55,19c-1.65-2.21-2.35-4.38-2.08-6.47.16-1.23.61-2.08,1.05-2.9.39-.73.77-1.43.95-2.42.39-2.05-.26-4.32-1.93-6.76l.86-.46c1.8,2.62,2.49,5.1,2.07,7.36-.21,1.11-.63,1.9-1.04,2.65-.42.79-.82,1.53-.96,2.62-.24,1.87.4,3.85,1.92,5.88l-.83.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartHeat);
export default __webpack_public_path__ + "static/media/start_heat.18c960cdb37d1b4b3ac919a2cff99f9e.svg";
export { ForwardRef as ReactComponent };